<!-- prettier-ignore -->
<div class="breadcrumb-container">
  @for (item of calculatedItems(); let last = $last; let first = $first; track item.id) {
    @if (!last || (first && last)) {
      <a [routerLink]="item.link" class="breadcrumb-item flex items-center gap-2">
        @if (first) {
          <app-icon src="/icons/left-arrow.svg" alt="Left arrow" />
        }

        <span>
          @if (item.label === '__loading__') {
            <div class="flex items-center justify-center">
              <ngx-skeleton-loader class="h-5 py-0.5" [theme]="{ width: '100px', height: '16px', 'background-color': 'var(--shikenso-gray-300)' }"/>
            </div>
          } @else {
            {{ item.label }}
          }
        </span>
      </a>

      @if (!first || !last) {
        <span class="separator">
          <app-icon src="/icons/chevron-right.svg" alt="Chevron right" />
        </span>
      }
    } @else {
      <span class="breadcrumb-item current">
        @if (item.label === loadingLabel) {
          <div class="flex items-center justify-center">
            <ngx-skeleton-loader class="h-5 py-0.5" [theme]="{ width: '100px', height: '16px', 'background-color': 'var(--shikenso-gray-300)' }"/>
          </div>
        } @else {
          {{ item.label }}
        }
      </span>
    }
  }
</div>
